import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/roundArrowRight.svg';

export const IconRoundArrowRight = createIconComponent(Icon);
